import * as ExpoApplication from "expo-application";
import Constants from "expo-constants";
import { Platform } from "react-native";
import { z } from "zod";

const parseScheme = (value: string | string[] | undefined) => {
  const scheme = Array.isArray(value) ? value.at(0) : (value ?? "");
  if (!scheme) throw new Error("Scheme is not found");
  return scheme;
};

const extraSchema = z.object({
  apple: z.object({
    appGroup: z.string(),
  }),
  isTV: z.boolean().optional(),
});

const envSchema = z.object({
  EXPO_PUBLIC_APP_VERSION: z.string().optional(),
  EXPO_PUBLIC_APP_BUILD_NUMBER: z.string().optional(),
});

const extra = extraSchema.parse(Constants.expoConfig?.extra);

const env = envSchema.parse({
  EXPO_PUBLIC_APP_VERSION: process.env.EXPO_PUBLIC_APP_VERSION,
  EXPO_PUBLIC_APP_BUILD_NUMBER: process.env.EXPO_PUBLIC_APP_BUILD_NUMBER,
});

export const APP_SCHEME = parseScheme(Constants.expoConfig?.scheme);

export const APP_APP_GROUP = extra.apple.appGroup;

export const IS_TV = extra.isTV === true;

export const APP_VERSION = Platform.select({
  web: env.EXPO_PUBLIC_APP_VERSION ?? Constants.expoConfig?.version,
  default: ExpoApplication.nativeApplicationVersion,
});

export const APP_BUILD_NUMBER = Platform.select({
  web: env.EXPO_PUBLIC_APP_BUILD_NUMBER,
  default: ExpoApplication.nativeBuildVersion,
});
